"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlattenedFlagsFromChangeset = void 0;

var getFlattenedFlagsFromChangeset = function getFlattenedFlagsFromChangeset(_a) {
  var changes = _a.changes;
  var flattened = {};

  for (var key in changes) {
    flattened[key] = changes[key].current;
  }

  return flattened;
};

exports.getFlattenedFlagsFromChangeset = getFlattenedFlagsFromChangeset;